var License = /** @class */ (function () {
    function License(values) {
        Object.assign(this, values);
        this.valid = new Date(values.valid);
    }
    return License;
}());
export default License;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Licenses/Model.ts
// module id = 328
// module chunks = 0